// Avatar and sizing constants
export const AVATAR_SIZE = 80;
export const GRADIENT_CUTOFF = 85;
export const PADDING_TOP = 20;

// Feature constants
export const PET_TYPE = 'pet'

// Pagination constants
export const ACHIEVEMENTS_PER_PAGE = 6;

// Animation constants
export const HOVER_TRANSITION_DURATION = '0.2s ease-in-out';

// Confetti constants
export const CONFETTI_DURATION = 5000;
export const CONFETTI_PIECES = 500;
export const CONFETTI_GRAVITY = 0.2;

// Achievement card dimensions
export const ACHIEVEMENT_CARD_WIDTH = 240;
export const ACHIEVEMENT_CARD_MIN_HEIGHT = 110;

// Modal constants
export const MODAL_MAX_WIDTH = "md";
export const DESCRIPTION_MAX_LENGTH = 100;

// Color constants
export const DEFAULT_BACKGROUND_COLOR = '#f9fafb';
export const HOVER_BACKGROUND_COLOR = '#f3f4f6';
export const DEFAULT_AVATAR_BACKGROUND = '#e5e7eb';
export const LOCKED_AVATAR_BACKGROUND = '#d1d5db'; 